<template src="./SolicitudRevisadaVer.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Col, Divider, Row, Tooltip} from "element-ui";
import {requestRevisionMixin} from "@/api/partidoPolitico/revisionApi";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from "moment-timezone";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import RevisionLayoutCollapse
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudRevisadaVer/Layout/RevisionLayoutCollapse";
import RevisionLayoutTab
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudRevisadaVer/Layout/RevisionLayoutTab";

export default {
  name: "SolicitudRevisadaVer",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tooltip.name]: Tooltip,
    RevisionLayoutCollapse,
    RevisionLayoutTab
  },
  mixins: [
    requestRevisionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    RouterMixin,
  ],
  data() {
    return {
      loading: true,
      errored: false,
      inRoute: false,
      collapse: ['1'],
      layout: 1,
      model: {
        id: "",
        rut: "",
        nombreCompleto: "",
        domicilio: "",
        fechaNacimiento: '',
        email: "",
        telefonoMovil: "",
        telefonoFijo: "",
        archivomanual: null,
        documentoFicha: null,
        estado: '',
        codigoestado: 0,

        revision: {
          estadoRevisionCodigo: 0,
          estadoRevision: '',

          motivoRechazoCodigo: 0,
          motivoRechazo: '',

          descripcionRechazo: '',
          instancia: '',
          fechaMaxima: '',
          revisionFecha: '',
          revisionFechaHora: '',
        },
        reclamacion: {
          reclamacionid: null,
          estadoRevision: 0,
          presentaReclamacion: 0,
          estadoRevisionCodigo: 0,
          estadoReclamacionCodigo: 0,
          estadoReclamacion: '',
          motivosRechazo: '',
          document: '',
        },

      },
    }
  },
  props: {
    idAfiliacion: {
      type: String,
      required: false
    }
  },
  computed: {
    operationLayoutContent() {
      return 'Interfaz de ' +  (this.layout === 1 ? 'pestañas' : 'acordeón')
    }
  },
  beforeMount() {
    this.getIdAfiliacion()
    this.getData()
  },
  methods: {
    getIdAfiliacion() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.model.id = this.$route.params.id
        this.inRoute = true
        this.collapse.push('2')
        this.collapse.push('3')
        this.collapse.push('4')
        this.collapse.push('5')
      } else {
        this.model.id = this.idAfiliacion
      }
    },
    getData() {
      this.getRevisionVer(this.model.id)
        .then((response) => {
          this.$log.debug('getRevisionVer', response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.model.rut = data.cedula
            this.model.nombreCompleto = data.nombrecompleto
            this.model.fechaNacimiento = moment(data.fechanacimiento, "YYYY-MM-DD").format('DD-MM-YYYY')
            this.model.email = data.email
            this.model.domicilio = data.domicilio
            this.model.telefonoMovil = data.telefonomovil
            this.model.telefonoFijo = data.telefonofijo
            this.model.estado = data.estado
            this.model.codigoestado = data.codigoestado
            this.model.afiliacionFecha = moment.utc(data.afiliacionfecha).local().format("DD-MM-YYYY")
            this.model.afiliacionFechaHora = moment.utc(data.afiliacionfecha).local().format("h:mm a")

            this.model.manual = data.manual
            this.model.archivomanual = data.archivomanual

            this.model.documentoFicha = data.documentoficha

            //revision
            this.model.revision.estadoRevisionCodigo = data.revisionestadocodigo
            this.model.revision.estadoRevision = data.revisionestado
            this.model.revision.motivoRechazoCodigo = data.revisionmotivocodigo
            this.model.revision.motivoRechazo = data.revisionmotivorechazo
            this.model.revision.descripcionRechazo = data.revisiondescripcion
            this.model.revision.instancia = data.revisioninstancia
            this.model.revision.fechaMaxima = moment(data.revisionplazomaxreclamo, "YYYY-MM-DD").format("DD-MM-YYYY")
            this.model.revision.revisionFecha = moment.utc(data.revisionfecha).local().format("DD-MM-YYYY")
            this.model.revision.revisionFechaHora = moment.utc(data.revisionfecha).local().format("h:mm a")

            //reclamacion
            this.model.reclamacion.reclamacionid = data.reclamacionid
            this.model.reclamacion.presentaReclamacion = parseInt(data.reclamacionpresentareclamacion)
            this.model.reclamacion.estadoReclamacionCodigo = data.reclamacionestadocodigo
            this.model.reclamacion.estadoReclamacion = data.reclamacionestado
            this.model.reclamacion.motivosRechazo = data.reclamacionrechazomotivo
            this.model.reclamacion.reclamacionFecha = moment.utc(data.reclamacionfecha).local().format("DD-MM-YYYY")
            this.model.reclamacion.reclamacionFechaHora = moment.utc(data.reclamacionfecha).local().format("h:mm a")
            this.model.reclamacion.document = data.reclamacionarchivo
          } else {
            this.errored = true;
            this.showInfo('No hay datos de su persona')
          }
        })
        .catch((err) => {
          this.$log.fatal('getRevisionVer', err, err.response, err.request)
          this.showError("Error al cargar la data de Afiliación")
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeLayout() {
      this.layout = this.layout === 1 ? 2 : 1
    }
  }
}
</script>
